var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "div",
    { staticClass: "w-full" },
    [
      _vm._t("header-content"),
      _vm._v(" "),
      _c("div", { staticClass: "flex center-xs space-top-1 w-full" }, [
        _c(
          "div",
          { staticClass: "flex vertical-center input-container w-full" },
          [
            _vm._t("body-content"),
            _vm._v(" "),
            _vm._l(_vm.step.valueList, function (value, index) {
              return _c("div", { key: value, staticClass: "radio-wrapper" }, [
                _c("input", {
                  directives: [
                    {
                      name: "model",
                      rawName: "v-model",
                      value: _vm.checkedValue,
                      expression: "checkedValue",
                    },
                  ],
                  staticClass: "hidden",
                  attrs: {
                    type: "radio",
                    id: _vm.step.name + index,
                    name: "name",
                  },
                  domProps: {
                    value: value,
                    checked: _vm._q(_vm.checkedValue, value),
                  },
                  on: {
                    change: function ($event) {
                      _vm.checkedValue = value
                    },
                  },
                }),
                _vm._v(" "),
                _c(
                  "label",
                  {
                    staticClass: "radio-box",
                    attrs: { for: _vm.step.name + index, tabindex: "0" },
                  },
                  [
                    _c("div", { staticClass: "mark-box flex start-xs" }, [
                      _c("span", { staticClass: "radio-check-circle" }),
                      _vm._v(" "),
                      _c("div", { staticClass: "radio-value" }, [
                        _vm._v(_vm._s(value)),
                      ]),
                    ]),
                  ]
                ),
              ])
            }),
            _vm._v(" "),
            _vm.dipslayErrorMessage
              ? _c("div", { staticClass: "red-text space-top-2" }, [
                  _vm._v(_vm._s(_vm.step.errorMessage)),
                ])
              : _vm._e(),
          ],
          2
        ),
      ]),
      _vm._v(" "),
      _vm._t("disclaimer"),
      _vm._v(" "),
      _vm.showButton
        ? _c("ButtonSection", {
            attrs: {
              inputValid: _vm.checkedValue !== "",
              order: _vm.order,
              buttonText: _vm.step.buttonText,
              exitButtonText: _vm.step.exitButtonText,
              backButtonText: _vm.step.backButtonText,
            },
            on: {
              progress: _vm.progress,
              "hide-modal": function ($event) {
                return _vm.$emit("hide-modal")
              },
              back: function ($event) {
                return _vm.$emit("back")
              },
            },
          })
        : _vm._e(),
      _vm._v(" "),
      _vm._t("login"),
    ],
    2
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }